import { DatePipe } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class AssinaturaService {
  private assinaturaSubject: BehaviorSubject<string> = new BehaviorSubject('');
  assinatura$ = this.assinaturaSubject.asObservable();

  private apiUrl = environment.API_URL;

  constructor(
    private http: HttpClient,
    private datePipe: DatePipe
  ) {
    
  }

  atualizarCodeAssinatura(code) {
    console.log('atualizarCodeAssinatura', code);
    this.assinaturaSubject.next(code);
  }

  enviarCodigoCallback(code) {
    return this.http.get(`${this.apiUrl}/assinador-digital/callback?code=${code}`);
  }

  getArquivoAssinado(token, arquivo) {
    const formData = new FormData();
    formData.append('arquivo', arquivo);

    return this.http.post(`${this.apiUrl}/assinador-digital/upload?token=${token}`, formData);
  }

  converterBase64ParaFile(base64) {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i <byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    return new File([byteArray], 'procuracao', { type: 'application/pdf' });
  }
}